import { useState } from 'react'

import { IconButton, Tooltip } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import DeleteIcon from '@material-ui/icons/Delete'
import EditContextProvider from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import MuiDatables from 'Components/UI/Atoms/Table'
import AutocompleteFilter from 'Components/UI/Atoms/Table/Autocomplete'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { RECEIPT_STATE, SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import Edit from './Edit'

const ReceiptTable = (props) => {
  const { dataBefore, values, setValues, render, setRender, permissions } = props
  const windowSize = useMediaQuery('(min-width:1000px)')

  const { state, setOpen, setClose } = SetState()
  const [loading, setLoading] = useState(false)
  const { state: remove, setOpen: openRemove, setClose: closeRemove } = SetState()

  const createDismissableSnackbar = useCustomSnackbar()

  async function receiptInfo(id, origen) {
    const empresaId = SUCURSAL_ORIGEN.find((sucursal) => sucursal.label === origen).id
    await interfaces.salesReceipt.infoOneReceipt(id, empresaId).then((res) => {
      setOpen({
        data: res.data,
      })
    })
  }

  async function apiCall(options, callback) {
    const params =
      typeof options === 'string'
        ? Object.fromEntries(new URLSearchParams(options))
        : { ...options }
    if (!params.origen) {
      params.origen = 'ECO'
    }
    const queryString = new URLSearchParams(params).toString()

    setValues({
      rows: [],
      header: [],
      permissions: {},
    })

    try {
      const result = await interfaces.salesReceipt.receiptList(`?${queryString}`)
      setValues({
        rows: result.data.data,
        header: result.header.header.count,
        permissions: result.data.permissions,
      })
      callback()
    } catch (error) {}
  }

  function openRemoveDialog(e, id, origen) {
    const origenLabel = SUCURSAL_ORIGEN.find((sucursal) => sucursal.label === origen.toUpperCase())
    const empresaId = origenLabel ? origenLabel.id : null
    e.stopPropagation()
    openRemove({ id: id, empresa: empresaId })
  }

  const deleteReceipt = async () => {
    const id = remove.id
    const empresa = remove.empresa
    setLoading(true)

    await interfaces.salesReceipt
      .deleteReceipt(id, empresa)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        setRender(!render)
      })
      .catch((err) => {
        createDismissableSnackbar(err.response.data.data, {
          variant: 'error',
        })
      })
    closeRemove()
    setLoading(false)
    setRender(!render)
  }

  const actions = (file) => {
    return (
      <div style={{ display: 'flex', marginLeft: '0.3rem' }}>
        <Tooltip title="Eliminar">
          <IconButton
            onClick={(e) => openRemoveDialog(e, file.id, file.origen)}
            size={windowSize ? 'medium' : 'normal'}
            disabled={file.estado === 'Borrador' ? false : true}
            style={{
              color: file.estado === 'Borrador' ? 'rgb(186, 79, 72)' : '#e0e0e0',
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    )
  }

  const RowsTransit = () =>
    values.rows.map((file) => [
      file.origen,
      file.fecha_creacion,
      file.usuario,
      file.nro_comprobante,
      file.cliente,
      file.monto ? `$${parseFloat(file.monto)}` : '$',
      file.estado,
      actions(file),
      '',
    ])

  let columns = [
    {
      name: 'origen',
      label: 'Origen',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Origen"
                  filterName="label"
                  options={SUCURSAL_ORIGEN}
                  defaultOption={{ label: 'ECO', id: 1 }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'fecha_creacion',
      label: 'Fecha creación',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'usuario',
      label: 'Usuario',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Usuario"
                  filterName="fullName"
                  options={dataBefore.data.usuarios}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'nro_comprobante',
      label: 'Nº comprobante',
      options: {
        filter: false,
        sort: false,
        fullWidth: true,
      },
    },
    {
      name: 'cliente',
      label: 'Cliente',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'monto',
      label: 'Monto',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'estado',
      label: 'Estado',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Estado"
                  filterName="label"
                  options={RECEIPT_STATE}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: '',
      label: '',
      options: {
        filter: false,
        sort: false,
      },
    },
  ]

  return (
    <>
      {state.suspense && (
        <EditContextProvider>
          <Edit
            open={state.open}
            handleclose={setClose}
            data={state.data}
            setRender={setRender}
            render={render}
            setLoading={setLoading}
            dataBefore={dataBefore}
            permissions={permissions}
            loading={loading}
          />
        </EditContextProvider>
      )}

      <MuiDatables
        columns={columns}
        data={RowsTransit()}
        rows={25}
        title={`Total de recibos: ${values.header}`}
        apiCall={apiCall}
        count={values.header}
        render={render}
        setRender={setRender}
        textPlaceholder="Buscar por nº de comprobante o cliente..."
        onRowClick={(_, index) =>
          receiptInfo(values.rows[index.dataIndex].id, values.rows[index.dataIndex].origen)
        }
        padding={windowSize ? '10px' : ''}
      />

      {remove.suspense && (
        <DialogComponent
          open={remove.open}
          title="¿Desea eliminar el siguiente recibo?"
          subtitle="¡Esta acción es irreversible!"
          handleclose={closeRemove}
          widthLarge="500px"
          maxHeight
          disableBackdropClick
          disableEscapeKeyDown
          actions={
            <CancelConfirmButtons
              onClickCancel={closeRemove}
              onClickSubmit={deleteReceipt}
              isLoading={loading}
              disabledSubmit={loading}
            />
          }
        />
      )}
    </>
  )
}
export default ReceiptTable
